import * as React from "react"

import { cn } from "@/lib/utils"

export const FLOATER_ARROW_WIDTH = 14
export const FLOATER_ARROW_HEIGHT = 7
// Keeps the arrow off the box's rounded corners.
export const FLOATER_ARROW_PADDING = 8

/**
 * The one arrow every anchored tip uses (tooltip, popover `arrow`), passed to a
 * Radix `Arrow` via `asChild`. Only the slanted sides are stroked, in the box's
 * own `--floater-edge` ring color, so no line crosses where the arrow meets the
 * box. The fill reaches a pixel up into the box to cover any subpixel seam
 * without moving the tip.
 *
 * The viewBox goes after the spread props: Radix's `Arrow` passes its own
 * `0 0 30 10` viewBox through `asChild`, which would squash this 14×7 shape
 * into the left half of the box and pull the tip off the anchor's center.
 */
export function FloaterArrowShape({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      {...props}
      viewBox={`0 0 ${FLOATER_ARROW_WIDTH} ${FLOATER_ARROW_HEIGHT}`}
      preserveAspectRatio="none"
      className={cn("overflow-visible", className)}
    >
      <path d="M0 -1 H14 V0 L7 7 L0 0 Z" className="fill-popover" />
      <path
        d="M0 0 L7 7 L14 0"
        className="fill-none stroke-(--floater-edge)"
        strokeWidth={1}
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}

/** Sets the box's ring color as `--floater-edge`, which the arrow strokes with. */
export const floaterEdgeClass =
  "[--floater-edge:color-mix(in_oklab,var(--color-foreground)_10%,transparent)] ring-1 ring-(--floater-edge)"
